import ChatWithMapView from '@/components/chat-bot/chatWithMapView';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/chat-bot/')({
  component: ChatBotRoute,
  validateSearch: (search) => ({
    entryPoint: typeof search.entryPoint === 'string' ? search.entryPoint : undefined,
  }),
  context: () => ({
    getBreadcrumbData: () => ({
      id: null,
      translationKey: 'breadcrumbs.chatBot',
    }),
  }),
  head: () => {
    return {
      meta: [
        {
          title: 'Chat Bot - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function ChatBotRoute() {
  return <ChatWithMapView />;
}
